// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__RgSSH","title":"style_title__2SrHF","text":"style_text__NVVgR","color":"style_color__3mNFI"};